import { BadgeProps } from '@/common/ui/badge'
import type { EventStatus, EventType, PeriodType } from './type'

// Event type options
export const EVENT_TYPE_OPTIONS = [
	{ label: 'ทั้งหมด', value: 'ALL' },
	{ label: 'กิจกรรมเทิร์นโอเวอร์', value: 'TURNOVER' },
] as const

// Event status options
export const EVENT_STATUS_OPTIONS = [
	{ label: 'ทั้งหมด', value: 'ALL' },
	{ label: 'แบบร่าง', value: 'DRAFT' },
	{ label: 'เปิดใช้งาน', value: 'ACTIVE' },
	{ label: 'สิ้นสุดแล้ว', value: 'ENDED' },
	{ label: 'ยกเลิกแล้ว', value: 'CANCELLED' },
] as const

// Period type options
export const PERIOD_TYPE_OPTIONS = [
	{ label: 'รายวัน', value: 'DAILY' },
	{ label: 'รายสัปดาห์', value: 'WEEKLY' },
	{ label: 'รายเดือน', value: 'MONTHLY' },
] as const

// Status badge variant mapping
export const EVENT_STATUS_BADGE_VARIANT: Record<
	EventStatus,
	BadgeProps['variant']
> = {
	DRAFT: 'secondary',
	ACTIVE: 'success',
	ENDED: 'outline',
	CANCELLED: 'destructive',
}

// Helper functions
export function getEventTypeLabel(type: EventType): string {
	const option = EVENT_TYPE_OPTIONS.find((opt) => opt.value === type)
	return option?.label || type
}

export function getEventStatusLabel(status: EventStatus): string {
	const option = EVENT_STATUS_OPTIONS.find((opt) => opt.value === status)
	return option?.label || status
}

export function getPeriodTypeLabel(periodType: PeriodType): string {
	const option = PERIOD_TYPE_OPTIONS.find((opt) => opt.value === periodType)
	return option?.label || periodType
}
